import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n';
import './index.css';
import Home from './pages/Home';
import { Lookup } from './pages/Lookup';
import { Directory } from './pages/Directory';
import { EntityDetail } from './pages/EntityDetail';
import { ScamList } from './pages/ScamList';
import { ScamDetail } from './pages/ScamDetail';
import { SmsAnalyze } from './pages/SmsAnalyze';
import { Privacy } from './pages/Privacy';
import { Disclaimer } from './pages/Disclaimer';
import { ImpersonationDomains } from './pages/ImpersonationDomains';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lookup" element={<Lookup />} />
        <Route path="/directory" element={<Directory />} />
        <Route path="/entity/:id" element={<EntityDetail />} />
        <Route path="/scams" element={<ScamList />} />
        <Route path="/scam/:id" element={<ScamDetail />} />
        <Route path="/sms" element={<SmsAnalyze />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/feedback" element={<Privacy />} />
        <Route path="/impersonation-domains" element={<ImpersonationDomains />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
